import React, { useState, useRef, useCallback, useEffect } from 'react';
import ReactDOM from 'react-dom/client';

import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';

import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';

import Select from 'react-select';

import Overlay from 'react-overlays/Overlay';
import Modal from 'react-overlays/Modal';
import useRootClose from 'react-overlays/useRootClose';

import PhotoSwipeLightbox from 'photoswipe/src/js/lightbox/lightbox';
import PhotoSwipe from 'photoswipe';
import 'photoswipe/src/photoswipe.css';

import { useQueryParams } from 'raviger';

import jsCookies from 'js-cookie';

import useWindowSize from 'use-window-size-v2';

import Icon from '@mdi/react';
import { mdiClockTimeSevenOutline, mdiMapMarkerOutline, mdiCheckCircleOutline, mdiAccountMultiple } from '@mdi/js';

import { isBefore, formatDate } from 'date-fns';
import { TZDate } from '@date-fns/tz';

import Logos from './logos';
import trans from './trans';

/*let content = 'key;lang (SL);lang (EN);lang (DE)\n';
for (let key in trans) {
	content += key;
	content += ';';
	content += trans[key]['sl']
		.replaceAll('\n', '\\n')
		.replaceAll('\r', '');
	content += ';';
	content += trans[key]['en']
		.replaceAll('\n', '\\n')
		.replaceAll('\r', '');
	content += ';';
	content += trans[key]['de']
		.replaceAll('\n', '\\n')
		.replaceAll('\r', '');
	content += '\n';
}
console.log({ content });*/

const DEV_MODE = process.env.DEV_MODE == 'true';
let BASE_URL = 'http://test.lodgge-api.local.mojaspletnastran.si/';
//let BASE_URL = 'https://sags.api.assistpro.eu/';
let CLIENT = 'test';
if (!DEV_MODE && document.location.host.indexOf('act-reservations.assistpro.eu') != -1) {
	CLIENT = document.location.host.substring(0, document.location.host.indexOf('act-reservations.assistpro.eu') - 1);
	BASE_URL = 'https://' + CLIENT + '.api.assistpro.eu/';
}

const HIDE_ACTIVITY_SELECTOR = true;
const DISPLAY_CHILD_PRICE_RANGE = false;

async function loadActivities(api_url) {
	let response = await fetch(api_url + 'PublicReservations/v1/activities');
	return await response.json();
}
async function loadAccommodations(api_url) {
	let response = await fetch(api_url + 'PublicReservations/v1/accommodations');
	return await response.json();
}
async function loadCountries(api_url) {
	let response = await fetch(api_url + 'PublicReservations/v1/countries');
	return await response.json();
}
async function calculatePrices(api_url, reservations) {
	const form_data = new FormData();
	form_data.append('activities', JSON.stringify(reservations));
	
	let response = await fetch(api_url + 'PublicReservations/v1/calculate-prices-activities', {
		method: 'POST',
		body: form_data,
	});
	return await response.json();
}
async function saveReservation(
	api_url,
	lang,
	reservations,
	agree_1,
	agree_2,
	customer_name,
	customer_surname,
	customer_email,
	customer_email_again,
	customer_id_country,
	customer_phone,
	customer_address,
	customer_post_code_name,
	customer_note,
	meeting_location
) {
	const form_data = new FormData();
	form_data.append('lang',                    lang                        );
	form_data.append('reservations',            JSON.stringify(reservations));
	form_data.append('agree_1',                 agree_1 ? 'true' : 'false'  );
	form_data.append('agree_2',                 agree_2 ? 'true' : 'false'  );
	form_data.append('customer_name',           customer_name               );
	form_data.append('customer_surname',        customer_surname            );
	form_data.append('customer_email',          customer_email              );
	form_data.append('customer_email_again',    customer_email_again        );
	form_data.append('customer_id_country',     customer_id_country         );
	form_data.append('customer_phone',          customer_phone              );
	form_data.append('customer_address',        customer_address            );
	form_data.append('customer_post_code_name', customer_post_code_name     );
	form_data.append('customer_note',           customer_note               );
	form_data.append('meeting_location',        meeting_location            );
	
	let response = await fetch(api_url + 'PublicReservations/v1/save-activity-reservation', {
		method: 'POST',
		body: form_data,
	});
	return await response.json();
}
async function getActivityPricesForTimeRange(api_url, date) {
	const params = [
		'date=' + encodeURIComponent(date),
	];
	
	let response = await fetch(api_url + 'PublicReservations/v1/activity-prices?' + params.join('&'));
	return await response.json();
}
async function getActivityOccupancy(api_url, date) {
	const params = [
		'date=' + encodeURIComponent(date),
	];
	
	let response = await fetch(api_url + 'PublicReservations/v1/activity-occupancy?' + params.join('&'));
	return await response.json();
}

const dateToISO = date => {
	const y = date.getFullYear();
	const m = date.getMonth() + 1;
	const d = date.getDate();
	return y + '-' + (m < 10 ? '0' : '') + m + '-' + (d < 10 ? '0' : '') + d;
};

const dateToLocalDate = date => {
	const y = date.getFullYear();
	const m = date.getMonth() + 1;
	const d = date.getDate();
	return (d < 10 ? '0' : '') + d + '.' + (m < 10 ? '0' : '') + m + '.' + y;
};

const formatNumber = (value, decimals) => value.toLocaleString(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals });

function App(props) {
	//const [ accommodationType, setAccommodationType ] = useState(null);
	//const [ selectedRoom, setSelectedRoom ] = useState(null);
	//const [ personCount, setPersonCount ] = useState([ 0, 0, 0 ]);
	
	const [ activities,             setActivities             ] = useState(null);
	const [ accommodations,         setAccommodations         ] = useState(null);
	const [ itemsByIds,             setItemsByIds             ] = useState(null);
	const [ countries,              setCountries              ] = useState(null);
	const [ cart,                   setCart                   ] = useState([]);
	const [ cartWithPrices,         setCartWithPrices         ] = useState([]);
	const [ successDialogOpen,      setSuccessDialogOpen      ] = useState(false);
	const [ errorDialogOpen,        setErrorDialogOpen        ] = useState(false);
	const [ errorDialogMessage,     setErrorDialogMessage     ] = useState(null);
	const [ itemPrices,             setItemPrices             ] = useState({});
	const [ accommodationOccupancy, setAccommodationOccupancy ] = useState({});
	const [ itemDescriptionDialogOpen, setItemDescriptionDialogOpen ] = useState(false);
	const [ itemDescriptionForDialog,  setItemDescriptionForDialog  ] = useState('');
	
	const [ customer_agree_1,        setCustomerAgree1       ] = useState('');
	const [ customer_agree_2,        setCustomerAgree2       ] = useState('');
	const [ customer_name,           setCustomerName         ] = useState(''); // useState('Tadej'); // useState('');
	const [ customer_surname,        setCustomerSurname      ] = useState(''); // useState('Kanižar'); // useState('');
	const [ customer_email,          setCustomerEmail        ] = useState({ value: '', valid: false }); // useState({ value: 'tadej@ncode.si', valid: true }); // useState({ value: '', valid: false });
	const [ customer_email_again,    setCustomerEmailAgain   ] = useState({ value: '', valid: false }); // useState({ value: 'tadej@ncode.si', valid: true }); // useState({ value: '', valid: false });
	const [ customer_id_country,     setCustomerIdCountry    ] = useState('');
	const [ customer_phone,          setCustomerPhone        ] = useState(''); // useState('123'); // useState('');
	const [ customer_address,        setCustomerAddress      ] = useState(''); // useState('Test'); // useState('');
	const [ customer_post_code_name, setCustomerPostCodeName ] = useState(''); // useState('Test'); // useState('');
	const [ customer_note,           setCustomerNote         ] = useState(''); // useState('Test'); // useState('');
	const [ meeting_location,        setMeetingLocation      ] = useState('location-1');
	
	const [ cartEditSelectedItem,    setCartEditSelectedItem ] = useState(null);
	
	console.log({ cart });
	
	// only execute once
	useEffect(() => {
		loadActivities    (BASE_URL).then(val => setActivities    (val));
		loadAccommodations(BASE_URL).then(val => setAccommodations(val));
		loadCountries     (BASE_URL).then(val => setCountries     (val));
		
		let link;
		
		link       = document.createElement('link');
		link.rel   = 'icon';
		link.type  = 'image/png';
		link.sizes = '32x32';
		link.href  = '/images/clients/' + CLIENT + '/favicon-32x32.png';
		document.getElementsByTagName('head')[0].appendChild(link);
		
		link       = document.createElement('link');
		link.rel   = 'icon';
		link.type  = 'image/png';
		link.sizes = '16x16';
		link.href  = '/images/clients/' + CLIENT + '/favicon-16x16.png';
		document.getElementsByTagName('head')[0].appendChild(link);
		
		link       = document.createElement('link');
		link.rel   = 'shortcut icon';
		link.href  = '/images/clients/' + CLIENT + '/favicon.ico';
		document.getElementsByTagName('head')[0].appendChild(link);
	}, []);
	
	const [ {
		lang,
		accommodationType,
		selectedIdItem,
		personCount,
		childAges,
		date,
		page,
	}, setQuery ] = useQueryParams();
	
	const paramLang              = lang              === undefined ? 'sl'        : lang;
	const paramAccommodationType = accommodationType === undefined ? null        : accommodationType;
	const paramSelectedIdItem    = selectedIdItem    === undefined ? null        : selectedIdItem;
	const paramPersonCount       = personCount       === undefined ? { adult: 2, child: 0 } : JSON.parse(personCount);
	const paramChildAges         = childAges         === undefined ? []          : JSON.parse(childAges);
	const paramDate              = date              === undefined || date  == '' ? null : new Date(date + 'T12:00:00');
	const paramPage              = page              === undefined ? 'index'     : page;
	console.log({
		paramDate,
		date,
	});
	
	const getCurrentParamsForQuery = () => {
		return {
			lang:              paramLang,
			accommodationType: paramAccommodationType,
			selectedIdItem:    paramSelectedIdItem,
			personCount:       JSON.stringify(paramPersonCount),
			childAges:         JSON.stringify(paramChildAges),
			date:              paramDate === null ? '' : dateToISO(paramDate),
			page:              paramPage,
		};
	};
	const setLang              = val => setQuery({ ...getCurrentParamsForQuery(), lang:              val });
	const setAccommodationType = val => setQuery({ ...getCurrentParamsForQuery(), accommodationType: val });
	const setSelectedIdType    = val => setQuery({ ...getCurrentParamsForQuery(), selectedIdItem:    val });
	const setPersonCount       = val => setQuery({ ...getCurrentParamsForQuery(), personCount:       JSON.stringify(val) });
	const setChildAges         = val => setQuery({ ...getCurrentParamsForQuery(), childAges:         JSON.stringify(val) });
	const setPage              = val => setQuery({ ...getCurrentParamsForQuery(), page:              val });
	const setDateRange = (date) => setQuery({
		...getCurrentParamsForQuery(),
		date: dateToISO(date),
	});
	
	useEffect(() => {
		//if (paramAccommodationType != 'room'     && paramSelectedIdItem     !== null) setSelectedIdType(null);
	}, [ paramAccommodationType ]);
	
	// load cart from cookie, if available
	useEffect(() => {
		const cookie_cart = jsCookies.get('cart');
		if (cookie_cart !== undefined) {
			console.log('setting cart from cookie: ' + cookie_cart);
			const cart = JSON.parse(cookie_cart);
			for (let i=0; i<cart.length; i++) {
				cart[i].date = new Date(cart[i].date);
			}
			
			setCart(cart);
		}
	}, []);
	
	// update prices
	useEffect(() => {
		async function load() {
			const response = await calculatePrices(BASE_URL, cart.map(x => {
				return {
					id_item:             x.id_item,
					id_item_item:        x.id_item_item,
					date:                dateToISO(x.date) + 'T12:00:00',
					person_count:        x.person_count,
					child_ages:          Object.values(x.child_ages).slice(0, x.person_count.child),
					services:            x.services,
					additional_services: x.additional_services,
					count:          x.count,
				};
			}));
			setCartWithPrices(response);
		}
		load();
		
		jsCookies.set('cart', JSON.stringify(cart));
	}, [ cart ]);
	
	// update items by ids
	useEffect(() => {
		const items = {};
		if (activities !== null) {
			for (let i=0; i<activities.length; i++) {
				const item = activities[i];
				items[item.id_activity] = item;
			}
		}
		setItemsByIds(items);
	}, [ activities ]);
	
	useEffect(() => {
		function load() {
			if (paramDate === null) return;
			
			getActivityPricesForTimeRange(BASE_URL, dateToISO(paramDate))
				.then(response => setItemPrices(response));
			
			getActivityOccupancy(BASE_URL, dateToISO(paramDate))
				.then(response => setAccommodationOccupancy(response));
		}
		load();
	}, [ date ]);
	
	const customerRef = useRef(null);
	const overviewRef = useRef(null);
	useEffect(() => {
		if (paramPage == 'overview' && overviewRef !== null && overviewRef.current !== null) {
			overviewRef.current.scrollIntoView({ behavior: 'smooth' });
		}
	}, [ paramPage ]);
	
	useEffect(() => {
		document.title = trans.fe__header__title[paramLang];
	}, [ paramLang ]);
	
	const floatingNextIndexRef = useRef(null);
	const floatingNextOverviewRef = useRef(null);
	
	// causes rerender, which is important because of calculating floating-next container height
	const screen_size = useWindowSize(100);
	const [ floatingNextHeight, setFloatingNextHeight ] = useState(0);
	
	const calculateFloatingNextHeight = () => {
		if (paramPage == 'index') {
			if (cart.length == 0 || floatingNextIndexRef.current === null) return 0;
			return floatingNextIndexRef.current.offsetHeight;
		}
		else if (paramPage == 'overview') {
			if (floatingNextOverviewRef.current === null) return 0;
			return floatingNextOverviewRef.current.offsetHeight;
		}
		return 0;
	};
	
	useEffect(() => {
		setTimeout(() => setFloatingNextHeight(calculateFloatingNextHeight()), 1000);
	}, [ paramPage, screen_size, floatingNextIndexRef, cart ]);
	
	// since we're returning here, there must not be any hooks after this point
	if (accommodations === null || countries === null) {
		return 'loading';
	}
	
	console.log({ paramPersonCount, paramChildAges });
	
	let fixed_child_ages = [];
	for (let i=0; i<paramPersonCount.child; i++) {
		fixed_child_ages.push(paramChildAges[i] ?? 0);
	}
	console.log({ fixed_child_ages });
	
	const pages = {
		'index': () => {
			let accommodation_components = null;
			if (paramDate !== null && accommodations !== null) {
				if (HIDE_ACTIVITY_SELECTOR || paramAccommodationType !== null) {
					accommodation_components =
						<AccommodationTypeActivity
							lang={paramLang}
							activities={activities}
							accommodations={accommodations}
							selectedIdItem={paramSelectedIdItem}
							accommodationType={accommodationType}
							setSelectedIdType={setSelectedIdType}
							onConfirmItem={item => {
								setCart([ ...cart, { ...item, date: paramDate, person_count: paramPersonCount, child_ages: fixed_child_ages } ]);
							}}
							prices={itemPrices}
							occupancy={accommodationOccupancy}
							cart={cart}
							date={paramDate}
							personCount={paramPersonCount}
							childAges={fixed_child_ages}
							onPopupItemDescription={description => {
								setItemDescriptionForDialog(description);
								setItemDescriptionDialogOpen(true);
							}} />;
				}
			}
			else {
				accommodation_components = <div
					className='empty-state'
					style={{ backgroundImage: 'url("' + Logos.sags + '")' }} />;
			}
			
			return <>
				<div className='main-selector'>
					<div className='main-selector-inner'>
						{HIDE_ACTIVITY_SELECTOR ? null : <div className='accommodation-selector'>
							<div className='accommodation-selector-title'>{ trans.fe__main_selector__accommodation_type[paramLang] }</div>
							<AccommodationTypeSelector lang={paramLang} value={paramAccommodationType} setValue={setAccommodationType} activities={activities} />
						</div>}
						<div className='person-counts-and-date'>
							<div className='date-selector'>
								<div className='date-selector-title'>{ trans.fe__main_selector__date_range[paramLang] }</div>
								<div>
									{accommodations === null ? null :
										<DateRange
											lang={paramLang}
											disabled={!HIDE_ACTIVITY_SELECTOR && paramAccommodationType === null}
											date={paramDate}
											setDateRange={setDateRange}
											accommodations={accommodations[paramAccommodationType]} />
									}
								</div>
							</div>
							<div>
								<div className='person-counts-title'>{ trans.fe__main_selector__person_count[paramLang] }</div>
								<div className='person-counts'>
									{[
										{ title: trans.fe__main_selector__person_adult[paramLang],   key: 'adult',   min: 1 },
										{ title: trans.fe__main_selector__person_child_1[paramLang], key: 'child', min: 0 },
									].map((item, idx) =>
										<div className='person-count' key={'person-count-' + idx}>
											<div className='person-count-input'>
												<button className='person-count-input-neg' disabled={paramPersonCount[item.key] == item.min} onClick={() => {
													const new_counts = {...paramPersonCount};
													new_counts[item.key] = Math.max(item.min, new_counts[item.key] - 1);
													setPersonCount(new_counts);
												}}>-</button>
												<div className='person-count-input-number'>{ paramPersonCount[item.key] }</div>
												<button className='person-count-input-pos' onClick={() => {
													const new_counts = {...paramPersonCount};
													new_counts[item.key]++; //TODO upper limit?
													setPersonCount(new_counts);
												}}>+</button>
											</div>
											<div className='person-count-title'>{ item.title }</div>
										</div>
									)}
								</div>
							</div>
						</div>
						{paramPersonCount.child == 0 ? null : <div>
							<div className='person-counts-title'>{ trans.fe__main_selector__child_ages[paramLang] }</div>
							<div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
								{new Array(paramPersonCount.child).fill(0).map((x, c) => <div key={'child-' + c} className='person-count' style={{ marginLeft: '0.5rem', marginRight: '0.5rem' }}>
									<div className='person-count-input'>
										<button className='person-count-input-neg' disabled={(paramChildAges[c] ?? 0) == 0} onClick={() => {
											const new_counts = {...paramChildAges};
											new_counts[c] = Math.max(0, (new_counts[c] ?? 0) - 1);
											setChildAges(new_counts);
										}}>-</button>
										<div className='person-count-input-number'>{ paramChildAges[c] ?? 0 }</div>
										<button className='person-count-input-pos' onClick={() => {
											const new_counts = {...paramChildAges};
											new_counts[c] = Math.min(17, (new_counts[c] ?? 0) + 1);
											setChildAges(new_counts);
										}}>+</button>
									</div>
									<div className='person-count-title'>{ (c + 1) + trans.fe__main_selector__child_age[paramLang] }</div>
								</div>)}
							</div>
						</div>}
					</div>
				</div>
				<div>
					{accommodation_components}
				</div>
				<div className={ 'floating-next floating-next-index ' + (cart.length == 0 ? 'hidden' : '') } ref={floatingNextIndexRef}>
					<div>
						<div className='cart-title'>{ trans.fe__bottom_bar__current_selection[paramLang] }</div>
						<div className='cart'>
							{cart.map((item, idx) => {
								const item_item = itemsByIds[item.id_item];
								if (item_item === undefined) return null;
								
								let item_item_item = null;
								for (let i=0; i<item_item.data.items.length; i++) {
									if (item_item.data.items[i].id_activity_item == item.id_item_item) {
										item_item_item = item_item.data.items[i];
									}
								}
								
								const arr = item.time_slot.starts_at.split(':');
								const starts_at = arr[0] + ':' + arr[1];
								
								return <React.Fragment key={'cart-item-' + idx}>
									<div className='large-gap'>{
										(item.count == 1 ? '' : (item.count + 'x ')) +
										item_item_item.title[paramLang]
									}</div>
									<div className='large-gap'>{
										trans.fe__bottom_bar__cart__person_count[paramLang] +
										' ' +
										(item.person_count.adult + item.person_count.child) +
										(
											[ item.person_count.adult, item.person_count.child ]
												.filter(x => x > 0)
												.length <= 1
													? ''
													: (
														' (' +
														[ item.person_count.adult, item.person_count.child ]
															.filter(x => x > 0)
															.join(' + ') +
														')'
													)
										)
									}</div>
									<div className='small-gap'>{ item.date.toLocaleDateString() } { starts_at }</div>
									<button
										className='button remove-button'
										onClick={() => {
											const new_cart = [ ...cart ];
											new_cart.splice(idx, 1);
											setCart(new_cart);
										}} />
								</React.Fragment>;
							})}
						</div>
						<div className='cart-mobile'>
							{cart.map((item, idx) => {
								const item_item = itemsByIds[item.id_item];
								if (item_item === undefined) return null;
								
								let item_item_item = null;
								for (let i=0; i<item_item.data.items.length; i++) {
									if (item_item.data.items[i].id_activity_item == item.id_item_item) {
										item_item_item = item_item.data.items[i];
									}
								}
								
								const arr = item.time_slot.starts_at.split(':');
								const starts_at = arr[0] + ':' + arr[1];
								
								return <React.Fragment key={'cart-item-' + idx}>
									<div className='cart-mobile-part-1'>
										<div className='large-gap flex-1'>{
											(item.count == 1 ? '' : (item.count + 'x ')) +
											item_item_item.title[paramLang]
										}</div>
										<div className='large-gap'>{ item.time_slot.time }</div>
										<button
											className='button remove-button'
											onClick={() => {
												const new_cart = [ ...cart ];
												new_cart.splice(idx, 1);
												setCart(new_cart);
											}} />
									</div>
									<div className='cart-mobile-part-2'>
										<div className='large-gap flex-1'>{
											trans.fe__bottom_bar__cart__person_count[paramLang] +
											' ' +
											(item.person_count.adult + item.person_count.child) +
											(
												[ item.person_count.adult, item.person_count.child ]
													.filter(x => x > 0)
													.length <= 1
														? ''
														: (
															' (' +
															[ item.person_count.adult, item.person_count.child ]
																.filter(x => x > 0)
																.join(' + ') +
															')'
														)
											)
										}</div>
										<div>{ item.date.toLocaleDateString() } { starts_at }</div>
									</div>
								</React.Fragment>;
							})}
						</div>
					</div>
					<div className='cart-continue'>
						<span>{ trans.fe__bottom_bar__continue_index_text[paramLang] }</span>
						<button className='button continue-button' onClick={() => setPage('overview')}>
							{ trans.fe__bottom_bar__continue[paramLang] }
						</button>
					</div>
				</div>
			</>;
		},
		'overview': () =>
			<PageOverview
				lang                    ={paramLang}
				accommodations          ={accommodations}
				countries               ={countries}
				cart                    ={cart}
				cart_with_prices        ={cartWithPrices}
				itemsByIds              ={itemsByIds}
				setPage                 ={page => setPage(page)}
				successDialogOpen       ={successDialogOpen}
				closeSuccessDialog      ={() => {
					setSuccessDialogOpen(false);
					if (!DEV_MODE) setCart([]);
					setPage('index');
				}}
				errorDialogOpen       ={errorDialogOpen}
				openErrorDialog       ={message => {
					setErrorDialogMessage(message);
					setErrorDialogOpen(true);
				}}
				closeErrorDialog      ={() => {
					setErrorDialogOpen(false);
				}}
				errorDialogMessage={errorDialogMessage}
				handleSaveReservationResult={() => {
					setSuccessDialogOpen(true);
				}}
				customer_name           ={customer_name}
				customer_surname        ={customer_surname}
				customer_email          ={customer_email}
				customer_email_again    ={customer_email_again}
				customer_id_country     ={customer_id_country}
				customer_phone          ={customer_phone}
				customer_address        ={customer_address}
				customer_post_code_name ={customer_post_code_name}
				customer_note           ={customer_note}
				customer_agree_1        ={customer_agree_1}
				customer_agree_2        ={customer_agree_2}
				meeting_location        ={meeting_location}
				setCustomerName         ={setCustomerName}
				setCustomerSurname      ={setCustomerSurname}
				setCustomerEmail        ={setCustomerEmail}
				setCustomerEmailAgain   ={setCustomerEmailAgain}
				setCustomerIdCountry    ={setCustomerIdCountry}
				setCustomerPhone        ={setCustomerPhone}
				setCustomerAddress      ={setCustomerAddress}
				setCustomerPostCodeName ={setCustomerPostCodeName}
				setCustomerNote         ={setCustomerNote}
				setCustomerAgree1       ={setCustomerAgree1}
				setCustomerAgree2       ={setCustomerAgree2}
				setMeetingLocation      ={setMeetingLocation}
				customerRef             ={customerRef}
				overviewRef             ={overviewRef}
				floatingNextOverviewRef ={floatingNextOverviewRef}
				floatingNextHeight      ={floatingNextHeight} />,
	};
	
	return <div
		className={ 'main-container main-container-' + paramPage }
		style={{ paddingBottom: floatingNextHeight }}>
		<div className='header'>
			<img className='logo' src={Logos.sags} />
			<div className='flex-1'></div>
			<div className='title'>
				<div>{ trans.fe__header__title[paramLang] }</div>
				<div className='subtitle'>{ trans.fe__header__subtitle[paramLang] }</div>
				{paramPage != 'index' ? null : <div className='subtitle'>{ trans.fe__header__subsubtitle[paramLang] }</div>}
			</div>
			<div className='flex-1'></div>
			<div className='header-right'>
				<div className='countries'>
					<img
						className={ 'country ' + (paramLang == 'sl' ? 'active' : '') }
						src={new URL('/src/images/countries/slovenia.png', import.meta.url)}
						onClick={() => setLang('sl')} />
					<img
						className={ 'country ' + (paramLang == 'en' ? 'active' : '') }
						src={new URL('/src/images/countries/united-kingdom.png', import.meta.url)}
						onClick={() => setLang('en')} />
					<img
						className={ 'country ' + (paramLang == 'de' ? 'active' : '') }
						src={new URL('/src/images/countries/germany.png', import.meta.url)}
						onClick={() => setLang('de')} />
				</div>
			</div>
		</div>
		{pages[paramPage]()}
		
		<Modal
			className='large-info-modal medium'
			show={itemDescriptionDialogOpen}
			onHide={() => setItemDescriptionDialogOpen(false)}
			renderBackdrop={() => <div className='large-info-modal-backdrop' onClick={() => setItemDescriptionDialogOpen(false)} />}>
			<div className='large-info-modal-wrapper'>
				<div className='large-info-modal-content'>
					<div dangerouslySetInnerHTML={{ __html: itemDescriptionForDialog }} />
				</div>
				<div className='large-info-modal-actions'>
					<button className='button primary-button' onClick={() => setItemDescriptionDialogOpen(false)}>
						{ trans.fe__error_dialog__close[paramLang] }
					</button>
				</div>
			</div>
		</Modal>
	</div>;
}

function PageOverview(props) {
	const [ loading,       setLoading       ] = useState(false);
	const [ fieldFailures, setFieldFailures ] = useState([]);
	
	if (props.cart_with_prices.length != props.cart.length) {
		// something went wrong, but we're probably just loading
		return null;
	}
	
	const country_options =
		props.countries.map(x => { return { value: x.id_country, label: x.official_name_international }; });
	
	return <>
		<div className='overview-header' ref={props.overviewRef}>
			<div>{ trans.fe__overview__title[props.lang] }</div>
		</div>
		<div className='overview'>
			<div className='overview-intro' dangerouslySetInnerHTML={{ __html: trans.fe__overview__intro[props.lang] }} />
			
			<div className='desktop'>
				<OverviewDesktop
					lang={props.lang}
					cart={props.cart}
					itemsByIds={props.itemsByIds}
					cart_with_prices={props.cart_with_prices} />
			</div>
			<div className='mobile'>
				<OverviewMobile
					lang={props.lang}
					cart={props.cart}
					itemsByIds={props.itemsByIds}
					cart_with_prices={props.cart_with_prices} />
			</div>
		</div>
		
		<div className='meeting-location'>
			<div className='meeting-location-title'>{ trans.fe__overview__meeting_location__title[props.lang] }</div>
			
			<div className='meeting-location-selection'>
				<div>
					<input type='radio' name='meeting-location' id='meeting-location-1' checked={props.meeting_location == 'location-1'} onClick={() => props.setMeetingLocation('location-1')} />
					<label htmlFor='meeting-location-1' dangerouslySetInnerHTML={{ __html: trans.fe__overview__meeting_location__location_1[props.lang] }} />
				</div>
				<div>
					<input type='radio' name='meeting-location' id='meeting-location-2' checked={props.meeting_location == 'location-2'} onClick={() => props.setMeetingLocation('location-2')} />
					<label htmlFor='meeting-location-2' dangerouslySetInnerHTML={{ __html: trans.fe__overview__meeting_location__location_2[props.lang] }} />
				</div>
			</div>
		</div>
		
		<div className='customer' ref={props.customerRef}>
			<div className='customer-title'>{ trans.fe__overview__customer__title[props.lang] }</div>
			
			<div className='customer-table'>
				<div className='customer-table-row'>
					<div className='customer-table-row-title'>{ trans.fe__overview__customer__name[props.lang] }</div>
					<div className='customer-table-row-value'>
						<input
							type='text'
							name='first-name'
							className={fieldFailures.indexOf('customer_name') == -1 ? '' : 'error'}
							value={props.customer_name}
							onChange={event => props.setCustomerName(event.target.value)} />
					</div>
				</div>
				<div className='customer-table-row'>
					<div className='customer-table-row-title'>{ trans.fe__overview__customer__surname[props.lang] }</div>
					<div className='customer-table-row-value'>
						<input
							type='text'
							name='last-name'
							className={fieldFailures.indexOf('customer_surname') == -1 ? '' : 'error'}
							value={props.customer_surname}
							onChange={event => props.setCustomerSurname(event.target.value)} />
					</div>
				</div>
				<div className='customer-table-row'>
					<div className='customer-table-row-title'>{ trans.fe__overview__customer__email[props.lang] }</div>
					<div className='customer-table-row-value'>
						<input
							type='email'
							name='email'
							className={fieldFailures.indexOf('customer_email') == -1 ? '' : 'error'}
							value={props.customer_email.value}
							onChange={event => props.setCustomerEmail({ value: event.target.value, valid: event.target.validity.valid })} />
					</div>
				</div>
				<div className='customer-table-row'>
					<div className='customer-table-row-title'>{ trans.fe__overview__customer__email_again[props.lang] }</div>
					<div className='customer-table-row-value'>
						<input
							type='email'
							className={
								props.customer_email.value.length > 0 && props.customer_email_again.value.length > 0 && props.customer_email.value != props.customer_email_again.value
									? 'error'
									: ''
							}
							value={props.customer_email_again.value}
							onChange={event => props.setCustomerEmailAgain({ value: event.target.value, valid: event.target.validity.valid })} />
					</div>
				</div>
				<div className='customer-table-row'>
					<div className='customer-table-row-title'>{ trans.fe__overview__customer__country[props.lang] }</div>
					<div className={ 'customer-table-row-value ' + (fieldFailures.indexOf('customer_id_country') == -1 ? '' : 'error') }>
						<Select
							placeholder=''
							options={country_options}
							value={props.customer_id_country === null ? null : country_options.filter(x => x.value == props.customer_id_country)[0]}
							onChange={(new_value, action_meta) => {
								switch (action_meta.action) {
									case 'remove-value':
									case 'pop-value':
										if (action_meta.removedValue.isFixed) {
											return;
										}
										break;
									case 'clear':
										new_value = null;
										break;
								}
								
								const prev_customer_id_country = props.customer_id_country;
								
								props.setCustomerIdCountry(new_value === null ? '' : new_value.value);
								if (new_value !== null) {
									const prev_country = prev_customer_id_country == '' ? null : props.countries.filter(x => x.id_country == prev_customer_id_country)[0];
									const country      = props.countries.filter(x => x.id_country == new_value.value)[0];
									if (props.customer_phone == '' || props.customer_phone == ('+' + (prev_country === null ? '' : prev_country.calling_code))) {
										props.setCustomerPhone('+' + country.calling_code);
									}
								}
							}} />
					</div>
				</div>
				<div className='customer-table-row'>
					<div className='customer-table-row-title'>{ trans.fe__overview__customer__phone[props.lang] }</div>
					<div className='customer-table-row-value'>
						<input
							type='text'
							name='phone'
							className={fieldFailures.indexOf('customer_phone') == -1 ? '' : 'error'}
							value={props.customer_phone}
							onChange={event => props.setCustomerPhone(event.target.value)} />
					</div>
				</div>
				{/*
				<div className='customer-table-row'>
					<div className='customer-table-row-title'>{ trans.fe__overview__customer__address[props.lang] }</div>
					<div className='customer-table-row-value'>
						<input
							type='text'
							name='address'
							className={fieldFailures.indexOf('customer_address') == -1 ? '' : 'error'}
							value={props.customer_address}
							onChange={event => props.setCustomerAddress(event.target.value)} />
					</div>
				</div>
				<div className='customer-table-row'>
					<div className='customer-table-row-title'>{ trans.fe__overview__customer__post_office[props.lang] }</div>
					<div className='customer-table-row-value'>
						<input
							type='text'
							name='post-code'
							className={fieldFailures.indexOf('customer_post_code_name') == -1 ? '' : 'error'}
							value={props.customer_post_code_name}
							onChange={event => props.setCustomerPostCodeName(event.target.value)} />
					</div>
				</div>
				*/}
				<div className='customer-table-row span-2'>
					<div className='customer-table-row-title' dangerouslySetInnerHTML={{ __html: trans.fe__overview__customer__note[props.lang] }} />
					<div className='customer-table-row-value'>
						<textarea
							className={fieldFailures.indexOf('customer_note') == -1 ? '' : 'error'}
							value={props.customer_note}
							onChange={event => props.setCustomerNote(event.target.value)} />
					</div>
				</div>
				<div className={ 'customer-table-row span-2 ' + (fieldFailures.indexOf('customer_agree_1') == -1 ? '' : 'error') }>
					<input type='checkbox' id='customer-agree-1' checked={props.customer_agree_1} onChange={e => props.setCustomerAgree1(e.target.checked) } />
					<label htmlFor='customer-agree-1' dangerouslySetInnerHTML={{ __html: trans.fe__overview__customer__agree_1[props.lang] }} />
				</div>
				<div className='customer-table-row span-2'>
					<input type='checkbox' id='customer-agree-2' checked={props.customer_agree_2} onChange={e => props.setCustomerAgree2(e.target.checked) } />
					<label htmlFor='customer-agree-2' dangerouslySetInnerHTML={{ __html: trans.fe__overview__customer__agree_2[props.lang] }} />
				</div>
			</div>
		</div>
		<div className={ 'floating-next floating-next-overview' } ref={props.floatingNextOverviewRef}>
			<div>
				<button className='button back-button' onClick={() => props.setPage('index')}>{ trans.fe__bottom_bar__back[props.lang] }</button>
			</div>
			<div>
				<button
					disabled={loading}
					className={ 'button continue-button ' + (loading ? 'saving' : '') }
					onClick={async () => {
						const field_validations = {
							customer_name:           props.customer_name             .length > 0,
							customer_surname:        props.customer_surname          .length > 0,
							customer_email:          props.customer_email.value      .length > 0,
							customer_email_again:    props.customer_email_again.value.length > 0,
							customer_phone:          props.customer_phone            .length > 0,
							//customer_address:        props.customer_address          .length > 0,
							//customer_post_code_name: props.customer_post_code_name   .length > 0,
							customer_id_country:     props.customer_id_country !== null && props.customer_id_country.length > 0,
							customer_agree_1:        props.customer_agree_1 === true,
						};
						const field_failures = Object.keys(field_validations).filter(field => !field_validations[field]);
						setFieldFailures(field_failures);
						
						let error_message = null;
						if (props.cart.length == 0) {
							error_message = trans.fe__error_dialog__validation_messages__empty_cart[props.lang];
						}
						else if (field_failures.length > 0) {
							error_message = trans.fe__error_dialog__validation_messages__required_fields[props.lang];
						}
						else if (!props.customer_email.valid) {
							error_message = trans.fe__error_dialog__validation_messages__invalid_email[props.lang];
						}
						else if (props.customer_email.value != props.customer_email_again.value) {
							error_message = trans.fe__error_dialog__validation_messages__emails_not_match[props.lang];
						}
						
						if (error_message !== null) {
							props.openErrorDialog(error_message);
							props.customerRef.current.scrollIntoView({ behavior: 'smooth' });
							return;
						}
						
						setLoading(true);
						const response = await saveReservation(
							BASE_URL,
							props.lang,
							props.cart,
							props.customer_agree_1,
							props.customer_agree_2,
							props.customer_name,
							props.customer_surname,
							props.customer_email.value,
							props.customer_email_again.value,
							props.customer_id_country,
							props.customer_phone,
							props.customer_address,
							props.customer_post_code_name,
							props.customer_note,
							props.meeting_location
						);
						setLoading(false);
						
						if (response.success === true) {
							props.handleSaveReservationResult();
						}
						else {
							switch (response.error ?? '') {
								case 'occupied':
									props.openErrorDialog(trans.fe__error_dialog__occupied[props.lang].replaceAll(
										'{reservations}',
										'<div class="occupied-errors">' +
											response.occupied_reservations.map(r =>
												'<div>' + props.itemsByIds[r.id_item].title[props.lang] + '</div>' +
												'<div>' +
													trans.fe__bottom_bar__cart__person_count[props.lang] + ' ' +
													(r.person_count.adult + r.person_count.child) +
												'</div>' +
												'<div class="text-right">' + new Date(r.date).toLocaleDateString() + '</div>'
											).join('') +
										'</div>'
									));
									
									break;
								case 'validation_failed':
								default:
									props.openErrorDialog(trans.fe__error_dialog__error_from_server[props.lang]);
							}
						}
					}}>
					{ trans.fe__bottom_bar__confirm[props.lang] }
					<div className='loader'></div>
				</button>
			</div>
		</div>
		
		<Modal
			className='confirmation-modal'
			show={props.successDialogOpen}
			onHide={props.closeSuccessDialog}
			renderBackdrop={() => <div className='confirmation-modal-backdrop' />}>
			<div>
				<div className='confirmation-modal-content'>
					<div dangerouslySetInnerHTML={{ __html: trans.fe__success_dialog__title[props.lang] }} />
					<div><img src={new URL('/src/images/check-circle-outline.svg', import.meta.url)} /></div>
					<div>
						<button
							className='button'
							onClick={props.closeSuccessDialog}>
							{ trans.fe__success_dialog__close[props.lang] }
						</button>
					</div>
				</div>
			</div>
		</Modal>
		
		<Modal
			className='error-modal'
			show={props.errorDialogOpen}
			onHide={props.closeErrorDialog}
			renderBackdrop={() => <div className='error-modal-backdrop' />}>
			<div>
				<div className='error-modal-content'>
					<div className='error-modal-content-title'>{ trans.fe__error_dialog__title[props.lang] }</div>
					<div dangerouslySetInnerHTML={{ __html: props.errorDialogMessage }} />
					<div><img src={new URL('/src/images/alert-circle-outline.svg', import.meta.url)} /></div>
					<div>
						<button
							className='button'
							onClick={props.closeErrorDialog}>
							{ trans.fe__error_dialog__close[props.lang] }
						</button>
					</div>
				</div>
			</div>
		</Modal>
	</>;
}

function OverviewDesktop(props) {
	let total_amount = 0;
	for (let i=0; i<props.cart_with_prices.length; i++) {
		total_amount += props.cart_with_prices[i].count * (
			(props.cart_with_prices[i].adult_price   ?? 0) * (props.cart_with_prices[i].adult_count   ?? 0) +
			(props.cart_with_prices[i].child_1_price ?? 0) * (props.cart_with_prices[i].child_1_count ?? 0) +
			(props.cart_with_prices[i].child_2_price ?? 0) * (props.cart_with_prices[i].child_2_count ?? 0) +
			(props.cart_with_prices[i].group_price ?? 0)
		);
	}
	
	const addSubPriceItem = (idx, type, title, count, price, discount) => {
		if (count == 0) return null;
		
		return <React.Fragment key={'cart-item-' + idx + '-' + type + '-subitem'}>
			<div className='overview-table-row service span-2 pl-1'>{ title }</div>
			<div className='overview-table-row service text-right pr-1'>{
				count + (price == 0 ? '' : (' x ' + formatNumber(price, 2))) +
				(discount == 0 ? '' : (' (-' + discount + '%)'))
			}</div>
		</React.Fragment>;
	};
	
	return <div className='overview-table'>
		<div className='overview-table-row-header'>{ trans.fe__overview__table__service[props.lang] }</div>
		<div className='overview-table-row-header'>{ trans.fe__overview__table__date_range[props.lang] }</div>
		<div className='overview-table-row-header text-right'>{ trans.fe__overview__table__price[props.lang] }</div>
		
		{props.cart.map((item, idx) => {
			let items = [];
			
			const item_item = props.itemsByIds[item.id_item];
			let item_item_item = undefined;
			if (item_item !== undefined) {
				for (let i=0; i<item_item.data.items.length; i++) {
					if (item_item.data.items[i].id_activity_item == item.id_item_item) {
						item_item_item = item_item.data.items[i];
						break;
					}
				}
			}
			
			if (item_item_item !== undefined) {
				const arr = item.time_slot.starts_at.split(':');
				const starts_at = arr[0] + ':' + arr[1];
				
				items.push(
					<React.Fragment key={'cart-item-' + idx}>
						<div className='overview-table-row'>{ item_item_item.title[props.lang] }</div>
						<div className='overview-table-row'>{
							item.date.toLocaleDateString() + ' ' + starts_at
						}</div>
						<div className='overview-table-row text-right main'>{
							(props.cart_with_prices[idx].count == 1 ? '' : (props.cart_with_prices[idx].count + 'x ')) +
							formatNumber(
								props.cart_with_prices[idx].adult_price * props.cart_with_prices[idx].adult_count +
								props.cart_with_prices[idx].child_1_price * props.cart_with_prices[idx].child_1_count +
								props.cart_with_prices[idx].child_2_price * props.cart_with_prices[idx].child_2_count +
								props.cart_with_prices[idx].group_price,
								2
							)
						}</div>
					</React.Fragment>
				);
				
				items.push(addSubPriceItem(
					idx,
					'adult',
					trans.fe__overview__table__person_adult[props.lang],
					props.cart_with_prices[idx].adult_count,
					props.cart_with_prices[idx].adult_price_without_discount,
					props.cart_with_prices[idx].adult_discount
				));
				if (props.cart_with_prices[idx].child_1_count > 0) {
					items.push(addSubPriceItem(
						idx,
						'child_1',
						trans.fe__overview__table__person_child_1[props.lang].replaceAll('{age}', item_item_item.child_age),
						props.cart_with_prices[idx].child_1_count,
						props.cart_with_prices[idx].child_1_price_without_discount,
						props.cart_with_prices[idx].child_1_discount
					));
				}
				if (props.cart_with_prices[idx].child_2_count > 0) {
					items.push(addSubPriceItem(
						idx,
						'child_2',
						trans.fe__overview__table__person_child_2[props.lang].replaceAll('{age}', item_item_item.child_age_2),
						props.cart_with_prices[idx].child_2_count,
						props.cart_with_prices[idx].child_2_price_without_discount,
						props.cart_with_prices[idx].child_2_discount
					));
				}
			}
			
			return items;
		})}
		
		<div className='overview-table-row-total span-2'>{ trans.fe__overview__table__total[props.lang] }</div>
		<div className='overview-table-row-total text-right'>{
			formatNumber(total_amount, 2) + ' €'
		}</div>
		
		<div className='overview-table-row span-3 note' dangerouslySetInnerHTML={{ __html: trans.fe__overview__tourist_tax[props.lang] }} />
		
		<div className='overview-table-row span-3 note warning-border' dangerouslySetInnerHTML={{ __html: trans.fe__overview__prepayment_description[props.lang] }} />
	</div>;
}
function OverviewMobile(props) {
	let total_amount = 0;
	for (let i=0; i<props.cart_with_prices.length; i++) {
		total_amount += props.cart_with_prices[i].count * (
			(props.cart_with_prices[i].adult_price   ?? 0) * (props.cart_with_prices[i].adult_count   ?? 0) +
			(props.cart_with_prices[i].child_1_price ?? 0) * (props.cart_with_prices[i].child_1_count ?? 0) +
			(props.cart_with_prices[i].child_2_price ?? 0) * (props.cart_with_prices[i].child_2_count ?? 0) +
			(props.cart_with_prices[i].group_price ?? 0)
		);
	}
	
	const addSubPriceItem = (idx, type, title, count, price, discount) => {
		if (count == 0) return null;
		
		return <React.Fragment key={'cart-item-' + idx + '-' + type + '-subitem'}>
			<div className='overview-table-row service pl-1'>{ title }</div>
			<div className='overview-table-row service text-right pr-1'>{
				count + (price == 0 ? '' : (' x ' + formatNumber(price, 2))) +
				(discount == 0 ? '' : (' (-' + discount + '%)'))
			}</div>
		</React.Fragment>;
	};
	
	return <div className='overview-table-mobile'>
		<div className='overview-table-row-header'>{ trans.fe__overview__table__service[props.lang] }</div>
		<div className='overview-table-row-header text-right'>{ trans.fe__overview__table__price[props.lang] }</div>
		
		{props.cart.map((item, idx) => {
			let items = [];
			
			const item_item = props.itemsByIds[item.id_item];
			let item_item_item = undefined;
			if (item_item !== undefined) {
				for (let i=0; i<item_item.data.items.length; i++) {
					if (item_item.data.items[i].id_activity_item == item.id_item_item) {
						item_item_item = item_item.data.items[i];
						break;
					}
				}
			}
			
			if (item_item_item !== undefined) {
				const arr = item.time_slot.starts_at.split(':');
				const starts_at = arr[0] + ':' + arr[1];
				
				items.push(
					<React.Fragment key={'cart-item-' + idx}>
						<div className='overview-table-row'>{ item_item_item.title[props.lang] }</div>
						<div className='overview-table-row text-right main'>{
							(props.cart_with_prices[idx].count == 1 ? '' : (props.cart_with_prices[idx].count + 'x ')) +
							formatNumber(
								props.cart_with_prices[idx].adult_price * props.cart_with_prices[idx].adult_count +
								props.cart_with_prices[idx].child_1_price * props.cart_with_prices[idx].child_1_count +
								props.cart_with_prices[idx].child_2_price * props.cart_with_prices[idx].child_2_count +
								props.cart_with_prices[idx].group_price,
								2
							)
						}</div>
						
						<div className='overview-table-row service span-2 pl-05'>{
							trans.fe__overview__table__date_range[props.lang] + ': ' +
							item.date.toLocaleDateString() +
							' ' +
							starts_at
						}</div>
				</React.Fragment>
				);
				
				items.push(addSubPriceItem(
					idx,
					'adult',
					trans.fe__overview__table__person_adult[props.lang],
					props.cart_with_prices[idx].adult_count,
					props.cart_with_prices[idx].adult_price_without_discount,
					props.cart_with_prices[idx].adult_discount
				));
				if (props.cart_with_prices[idx].child_1_count > 0) {
					items.push(addSubPriceItem(
						idx,
						'child_1',
						trans.fe__overview__table__person_child_1[props.lang].replaceAll('{age}', item_item_item.child_age),
						props.cart_with_prices[idx].child_1_count,
						props.cart_with_prices[idx].child_1_price_without_discount,
						props.cart_with_prices[idx].child_1_discount
					));
				}
				if (props.cart_with_prices[idx].child_2_count > 0) {
					items.push(addSubPriceItem(
						idx,
						'child_2',
						trans.fe__overview__table__person_child_2[props.lang].replaceAll('{age}', item_item_item.child_age_2),
						props.cart_with_prices[idx].child_2_count,
						props.cart_with_prices[idx].child_2_price_without_discount,
						props.cart_with_prices[idx].child_2_discount
					));
				}
			}
			
			return items;
		})}
		
		<div className='overview-table-row-total'>{ trans.fe__overview__table__total[props.lang] }</div>
		<div className='overview-table-row-total text-right'>{
			formatNumber(total_amount, 2) + ' €'
		}</div>
		
		<div className='overview-table-row span-2 note' dangerouslySetInnerHTML={{ __html: trans.fe__overview__tourist_tax[props.lang] }} />
		
		<div className='overview-table-row span-2 note warning-border' dangerouslySetInnerHTML={{ __html: trans.fe__overview__prepayment_description[props.lang] }} />
	</div>;
}

function DateRange(props) {
	const [ open, setOpen ] = useState(false);
	
	const containerRef = useRef(null);
	const targetRef = useRef(null);
	
	const screen_size = useWindowSize(100);
	const screen_width = screen_size.width;
	
	const rangeIncludesReservedDays = range => {
		let c = 0;
		let d = range[0];
		while (true) {
			if (props.accommodations !== undefined && props.accommodations.reserved_by_days.indexOf(d) != -1) return true;
			
			d = dateToISO(new Date(new Date(d).getTime() + 24*60*60*1000));
			// stop when we get to last day (skip last day, since that is check out)
			if (d == range[1]) break;
			
			c++;
			if (c > 20) break;
		}
		return false;
	};
	
	return <div ref={containerRef} style={{ position: 'relative' }}>
		<button
			className='button date-selector-button'
			disabled={props.disabled}
			ref={targetRef}
			onClick={() => setOpen(!open)}>
			<div>{ props.date === null
				? trans.fe__main_selector__date_range_empty[props.lang]
				: props.date.toLocaleDateString()
			}</div>
			<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' style={{ width: 24, height: 24 }}><path style={{ fill: '#666666' }} d='M9,10V12H7V10H9M13,10V12H11V10H13M17,10V12H15V10H17M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5A2,2 0 0,1 5,3H6V1H8V3H16V1H18V3H19M19,19V8H5V19H19M9,14V16H7V14H9M13,14V16H11V14H13M17,14V16H15V14H17Z' /></svg>
		</button>
		<Modal
			className='calendar-modal'
			show={open}
			onHide={() => setOpen(false)}
			renderBackdrop={() => <div className='calendar-modal-backdrop' onClick={() => setOpen(false)} />}>
				<Calendar
					locale={props.lang}
					onChange={(val) => {
						const date_iso = dateToISO(val);
						
						if (!rangeIncludesReservedDays([ date_iso ])) {
							props.setDateRange(
								val === null ? null : val
							);
							setOpen(false);
						}
					}}
					value={props.date}
					selectRange={false}
					showDoubleView={false}
					minDate={new Date()}
					maxDate={new Date('2040-12-31T12:00:00')}
					tileDisabled={({ date, view }) => {
						if (view == 'month') {
							const date_iso = dateToISO(date);
							//if (date_iso < '2024-08-24') return true;
							return props.accommodations !== undefined && props.accommodations.reserved_by_days.indexOf(date_iso) != -1;
						}
						return false;
					}} />
			</Modal>
	</div>;
	
	/*return <DateRangePicker onChange={(val) => {
		console.log({ val });
		setDateFrom (val === null ? null : val[0]);
		setDateUntil(val === null ? null : val[1]);
	}} value={[ dateFrom, dateUntil ]} />;*/
}

function AccommodationTypeSelector(props) {
	const colourStyles = {
		control: (styles) => ({ ...styles }),
		option: (styles, { data, isDisabled, isFocused, isSelected }) => {
			//const color = chroma(data.color);
			return {
				...styles,
				/*backgroundColor:
					isDisabled
					? undefined
					: isSelected
					? data.color
					: isFocused
					? color.alpha(0.1).css()
					: undefined,
				cursor: isDisabled ? 'not-allowed' : 'default',
				color:
					isDisabled
					? '#ccc'
					: isSelected
					? chroma.contrast(color, 'white') > 2
					? 'white'
					: 'black'
					: data.color,
				':active': {
					...styles[':active'],
					backgroundColor:
						!isDisabled
						? isSelected
						? data.color
						: color.alpha(0.3).css()
						: undefined,
				},*/
			};
		},
		input: (styles) => ({ ...styles }),
		placeholder: (styles) => ({ ...styles }),
		singleValue: (styles, { data }) => ({ ...styles }),
		groupHeading: (styles, { data }) => ({ ...styles, marginLeft: -20 }),
		group: (styles, { data }) => ({ ...styles, paddingLeft: 20 }),
	};
	
	const values = {};
	const options = [];
	if (props.activities !== null) {
		for (let i=0; i<props.activities.length; i++) {
			values[props.activities[i].id_activity] = { label: props.activities[i].title[props.lang], value: props.activities[i].id_activity };
			options.push(values[props.activities[i].id_activity]);
		}
	}
	
	return <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center' }}>
		{options.map((x, idx) =>
			<button
				key={'item-' + x.value}
				className={
					'button ' +
					(x.value === props.value ? 'primary-button' : '')
				}
				style={{ whiteSpace: 'nowrap', marginLeft: 4, marginRight: 4, marginBottom: 8 }}
				onClick={() => props.setValue(x.value)}>
				{ x.label }
			</button>
		)}
	</div>;
}

function AccommodationTypeActivity(props) {
	const [ itemGalleryOpenIdx, setItemGalleryOpenIdx ] = useState(-1);
	const [ selectedItem,       setSelectedItem       ] = useState(null);
	const [ expanded,           setExpanded           ] = useState(false);
	
	let activity = null;
	let act = null;
	if (props.activities !== null) {
		for (let i=0; i<props.activities.length; i++) {
			if (props.activities[i].id_activity == props.accommodationType) {
				activity = props.activities[i].data ?? {};
				act      = props.activities[i];
				break;
			}
		}
	}
	
	let items = [];
	if (activity !== null && act !== null) {
		items = Object.values(activity?.items ?? []).map(item => {
			return { activity: act, ...item, images: item.images.map(image => ({ src: image })) };
		});
	}
	else if (HIDE_ACTIVITY_SELECTOR && props.activities !== null) {
		for (let i=0; i<props.activities.length; i++) {
			items = items.concat(
				Object.values(props.activities[i].data.items).map(item => {
					return { activity: props.activities[i], ...item, images: item.images.map(image => ({ src: image })) };
				})
			);
		}
	}
	
	useEffect(() => {
		if (itemGalleryOpenIdx == -1) return;
		
		let lightbox = new PhotoSwipeLightbox({
			dataSource: items[itemGalleryOpenIdx].images,
			pswpModule: PhotoSwipe,
		});
		
		lightbox.on('beforeOpen', () => {
			const pswp = lightbox.pswp;
			const ds = pswp.options.dataSource;
			if (Array.isArray(ds)) {
				for (let idx = 0, len = ds.length; idx < len; idx++) {
					const item = ds[idx];
					const img = new Image();
					img.onload = () => {
						item.width = img.naturalWidth;
						item.height = img.naturalHeight;
						pswp.refreshSlideContent(idx);
					};
					img.src = item.src;
				}
			}
		});
		lightbox.on('close', () => {
			setItemGalleryOpenIdx(-1);
		});
		
		lightbox.init();
		lightbox.loadAndOpen(0);
		
		return () => {
			lightbox.destroy();
			lightbox = null;
		};
	}, [ itemGalleryOpenIdx ]);
	
	let current_date_iso = dateToISO(props.date);
	let current_date_weekday = {
		0: 'sunday',
		1: 'monday',
		2: 'tuesday',
		3: 'wednesday',
		4: 'thursday',
		5: 'friday',
		6: 'saturday',
	}[props.date.getDay()];
	
	const findHourLimit = (hour_limit_for_reservation_arr, date, time_idx) => {
		const date_iso = dateToISO(date);
		
		let hour = hour_limit_for_reservation_arr.length == 0 ? null : hour_limit_for_reservation_arr[0]['hour_' + time_idx];
		for (let i=1; i<hour_limit_for_reservation_arr.length; i++) {
			if (date_iso >= hour_limit_for_reservation_arr[i].date_from && date_iso <= hour_limit_for_reservation_arr[i].date_until) {
				hour = hour_limit_for_reservation_arr[i]['hour_' + time_idx];
			}
		}
		
		return hour;
	};
	const availableForReservation = (hour_limit_for_reservation, date, time_idx, starts_at) => {
		const curr_date = TZDate.tz('Europe/Ljubljana');

		const hour_limit = hour_limit_for_reservation === null ? 0 : (findHourLimit(
			hour_limit_for_reservation,
			date,
			time_idx
		) ?? 0);						
		
		const arr = starts_at.split(':');
		const tz_date = new TZDate(
			date.getFullYear(),
			date.getMonth(),
			date.getDate(),
			arr[0] - hour_limit,
			arr[1],
			0,
			'Europe/Ljubljana'
		);

		return isBefore(curr_date, tz_date);
	};
	
	return <div>
		<div className='accommodation-type-description'>
			<ul style={{ listStyle: 'disc inside' }} dangerouslySetInnerHTML={{ __html: activity?.description_1[props.lang] }} />
			<ul style={{ listStyle: 'disc inside', display: expanded ? 'block' : 'none' }} dangerouslySetInnerHTML={{ __html: activity?.description_2[props.lang] }} />
			{(activity?.description_2[props.lang] ?? '').length == 0 ? null : <button
				className={'accommodation-type-description-expand ' + (expanded ? 'expanded' : '')}
				onClick={() => setExpanded(!expanded)}>
				<div className='accommodation-type-description-expand-icon'></div>
				<div className='accommodation-type-description-expand-text'>
					<span className='collapsed'>{ trans.fe__accommodation_room__show_more[props.lang] }</span>
					<span className='expanded'>{ trans.fe__accommodation_room__show_less[props.lang] }</span>
				</div>
			</button>}
		</div>
		<div className='accommodation-items'>
			{items.map((item, idx) => {
				let accommodation_item_schedule = null;
				for (let i=0; i<item.activity.time_slots.length; i++) {
					if (
						item.activity.time_slots[i].valid_from <= current_date_iso &&
						(item.activity.time_slots[i].valid_until === null || item.activity.time_slots[i].valid_until >= current_date_iso) &&
						(accommodation_item_schedule === null || item.activity.time_slots[i].valid_from > accommodation_item_schedule.valid_from)
					) {
						accommodation_item_schedule = item.activity.time_slots[i];
					}
				}
				const all_time_slots = accommodation_item_schedule === null ? [] : accommodation_item_schedule.time_slots;
				const time_slots_by_ids = {};
				for (let i=0; i<all_time_slots.length; i++) {
					time_slots_by_ids[all_time_slots[i].id_accommodation_item_schedule_time_slot_activity] = all_time_slots[i];
				}
				let time_slots = all_time_slots.filter(x => {
					if (x.hidden_from_public && x.override_visibility_when_sibling_over_limit_id !== null) {
						const sibling_time_slot = time_slots_by_ids[x.override_visibility_when_sibling_over_limit_id];
						if (sibling_time_slot === undefined) return false;
						
						const activity_occupancy = props.occupancy[item.id_activity];
						if (activity_occupancy === undefined) return false;
						
						const sibling_time_slot_occupancy = activity_occupancy[sibling_time_slot.starts_at];
						if (sibling_time_slot_occupancy === undefined) return false;
						
						const cart_count = props.cart
							.filter(y =>
								dateToISO(y.date)     == dateToISO(props.date)       &&
								y.time_slot.starts_at == sibling_time_slot.starts_at &&
								y.id_item             == item.id_activity            &&
								y.id_item_item        == item.id_activity_item
							)
							.reduce((acc, val) => acc + val.person_count.adult + val.person_count.child, 0);
						const count_selected = props.personCount.adult + props.personCount.child;

						// hide if sibling is under limit
						if ((sibling_time_slot_occupancy.count + cart_count + count_selected) <= sibling_time_slot_occupancy.limit) return false;

						// hide if this time slot would be over limit anyway
						const time_slot_occupancy = activity_occupancy[x.starts_at];
						if (time_slot_occupancy === undefined) return false;
						if ((time_slot_occupancy.count + count_selected) > time_slot_occupancy.limit) return false;

						// hide if it's not available (time-wise)
						if (!availableForReservation(item.hour_limit_for_reservation, props.date, x.time_idx, x.starts_at)) {
							return false;
						}
					}
					else if (x.hidden_from_public) {
						return false;
					}
					
					return x.day_of_week == current_date_weekday;
				});
				time_slots.sort((a, b) => {
					if (a.starts_at > b.starts_at) return 1;
					if (a.starts_at < b.starts_at) return -1;
					return 0;
				});
				
				return <AccommodationItem
					key={'room-' + item.id_activity + '-' + item.id_activity_item}
					lang={props.lang}
					selected={false}
					item={item}
					idx={idx}
					price={props.prices === undefined || props.prices[item.id_activity] === undefined || props.prices[item.id_activity][item.id_activity_item] === undefined
						? { adult: 0, child: 0, group: null, group_max: null }
						: props.prices[item.id_activity][item.id_activity_item]
					}
					occupancy={props.occupancy[item.id_activity]}
					max_people_exceeded={false}
					time_slots={time_slots}
					person_count={props.personCount}
					cart={props.cart}
					date={props.date}
					child_ages={props.childAges}
					onItemSelect={(time_slot, count) => {
						//if (item.additional_services.length == 0) {
							props.onConfirmItem(
								{ id_item: item.id_activity, id_item_item: item.id_activity_item, time_slot, count }
							);
						//}
						//else {
						//	setSelectedItem(item);
						//}
					}}
					onImageClick={() => setItemGalleryOpenIdx(idx)}
					onPopupItemDescription={props.onPopupItemDescription}
					accommodation_item_schedule={accommodation_item_schedule}
					findHourLimit={findHourLimit}
					availableForReservation={availableForReservation} />;
			})}
		</div>
	</div>;
}

function AccommodationItem(props) {
	if (props.time_slots === null) return null;
	
	let cls = 'accommodation-item ';
	if (props.selected === true) {
		cls += 'selected ';
	}
	
	//else if (props.already_in_cart === true) {
	//	cls += 'already-in-cart ';
	//}
	else if (props.max_people_exceeded === true) {
		cls += 'max-people-exceeded ';
	}
	
	/*console.log({
		person_count: props.person_count,
		cart: props.cart,
	});*/
	
	const icons = {
		'duration': mdiClockTimeSevenOutline,
		'length':   mdiMapMarkerOutline,
		'check':    mdiCheckCircleOutline,
		'people':   mdiAccountMultiple,
	};
	
	const valid_child_ages = props.person_count.child == 0 || props.child_ages.every(x => x > 0);
	const min_child_age    = props.person_count.child == 0 ? null : props.child_ages.reduce((acc, val) => Math.min(acc, val), 99);
	//console.log({ min_child_age, min_age: props.item.min_age });
	
	const above_min_child_age = min_child_age === null || min_child_age >= props.item.min_age;
	
	let child_price = null;
	if (props.price.child !== null && props.price.child !== undefined &&
		props.price.child_2 !== null && props.price.child_2 !== undefined &&
		props.price.child != props.price.child_2) {
		if (DISPLAY_CHILD_PRICE_RANGE) {
			child_price = <span><strong>{
				formatNumber(Math.min(props.price.child, props.price.child_2), 2) +
				'-' +
				formatNumber(Math.max(props.price.child, props.price.child_2), 2)
			} €</strong> { trans.fe__accommodation_room__per_children[props.lang] }</span>;
		}
		else {
			child_price = <span><strong>{
				formatNumber(Math.min(props.price.child, props.price.child_2), 2)
			} €</strong> { trans.fe__accommodation_room__per_children[props.lang] }</span>;
		}
	}
	else if (props.price.child !== null && props.price.child !== undefined) {
		child_price = <span><strong>{ formatNumber(props.price.child, 2) } €</strong> { trans.fe__accommodation_room__per_children[props.lang] }</span>;
	}
	else if (props.price.child_2 !== null && props.price.child_2 !== undefined) {
		child_price = <span><strong>{ formatNumber(props.price.child_2, 2) } €</strong> { trans.fe__accommodation_room__per_children[props.lang] }</span>;
	}
	
	let show_error_message = false;
	
	return <div
		className={cls}
		key={'item-' + props.item.id_activity_item}
		style={{
			opacity: 0,
			animation: (props.max_people_exceeded === true ? 'fadeInReserved' : 'fadeIn') + ` 500ms ease-out ${props.idx * 100}ms forwards`,
		}}>
		<div
			className={'accommodation-item-image ' + (props.onImageClick === null ? '' : 'clickable')}
			style={
				props.item.image == ''
					? {}
					: { backgroundImage: 'url("' + props.item.image + '")' }
			}
			onClick={props.onImageClick}>
			{props.onImageClick === null
				? null
				: <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><path d='M22,16V4A2,2 0 0,0 20,2H8A2,2 0 0,0 6,4V16A2,2 0 0,0 8,18H20A2,2 0 0,0 22,16M11,12L13.03,14.71L16,11L20,16H8M2,6V20A2,2 0 0,0 4,22H18V20H4V6' /></svg>
			}
		</div>
		<div className='accommodation-item-first-line' style={{ display: 'block' }}>
			<div className='accommodation-item-title' style={{ textAlign: 'center' }}><em>{ props.item.title[props.lang] }</em></div>
		</div>
		<div className='accommodation-item-price-desc2' style={{ paddingTop: 0, paddingLeft: 16, paddingRight: 16, paddingBottom: 8, textAlign: 'center', borderBottom: '1px solid #888888', marginBottom: 8 }}>
			<div>
				{props.price.group !== null && props.price.group_max !== null
					? <span style={{ paddingRight: '1rem' }}>
						<strong>{ formatNumber(props.price.group, 2) + ' - ' + formatNumber(props.price.group_max, 2) } €</strong>
						{ trans.fe__accommodation_room__per_group[props.lang] }
					</span>
					: null
				}
				{props.price.group !== null && props.price.group_max === null
					? <span style={{ paddingRight: '1rem' }}><strong>{ formatNumber(props.price.group, 2) } €</strong> { trans.fe__accommodation_room__per_group[props.lang] }</span>
					: null
				}
				{props.price.group === null && props.price.group_max === null
					? <>
						<span style={{ paddingRight: '1rem' }}><strong>{ formatNumber(props.price.adult, 2) } €</strong> { trans.fe__accommodation_room__per_adults[props.lang] }</span>
						{child_price}
					</>
					: null
				}
			</div>
		</div>
		<div className='accommodation-item-meta-data-container'>
			<div className='accommodation-item-meta-data'>
				{props.item.meta_data.filter(meta_data_item => meta_data_item.key != 'permit').map((meta_data_item, idx) => <div key={'meta-data-' + idx} className='accommodation-item-meta-data-item'>
					{icons[meta_data_item.key] === undefined ? null : <Icon path={icons[meta_data_item.key]} size={1.5} title={ meta_data_item.alt[props.lang] ?? '' } />}
					<div dangerouslySetInnerHTML={{ __html: meta_data_item.title[props.lang].replaceAll('\\n', '<br />') }} />
				</div>)}
			</div>
			<div className='accommodation-item-meta-data'>
				{props.item.meta_data.filter(meta_data_item => meta_data_item.key == 'permit').map((meta_data_item, idx) => <div key={'meta-data-' + idx} className='accommodation-item-meta-data-item'>
					{icons[meta_data_item.key] === undefined ? null : <Icon path={icons[meta_data_item.key]} size={1.5} title={ meta_data_item.alt[props.lang] ?? '' } />}
					<div dangerouslySetInnerHTML={{ __html: meta_data_item.title[props.lang].replaceAll('\\n', '<br />') }} />
				</div>)}
			</div>
		</div>
		{(props.item.description[props.lang].length > 0 || props.item.extended_description[props.lang].length > 0) && <div className='accommodation-item-description'>
			<div dangerouslySetInnerHTML={{
				__html: props.item.description[props.lang].replaceAll('{space}', '<span style="padding-left: 1.5rem;"></span>')
			}} />
			{props.item.extended_description[props.lang].length == 0
				? null
				: <button
					className='accommodation-item-show-extended-description'
					onClick={() => props.onPopupItemDescription(props.item.extended_description[props.lang])}>
					{ trans.fe__accommodation_room__show_more[props.lang] }
				</button>
			}
		</div>}
		
		<div className='accommodation-item-select'>
			{props.item.limit_to_email_inquiry === true ? null : <div className='buttons'>
				<div>{ trans.fe__accommodation_room__select_time_slot[props.lang] }</div>
				<div className='buttons-wrapper'>
					{props.time_slots.map(time_slot => {
						if (props.occupancy === null || props.occupancy === undefined || props.occupancy[time_slot.starts_at] === undefined) return null;

						// counts
						const count_cart = props.cart
							.filter(x =>
								dateToISO(x.date)     == dateToISO(props.date)       &&
								x.time_slot.starts_at == time_slot.starts_at         &&
								x.id_item             == props.item.id_activity      &&
								x.id_item_item        == props.item.id_activity_item
							)
							.reduce((acc, val) => acc + val.person_count.adult + val.person_count.child, 0);
						const count_selected      = props.person_count.adult + props.person_count.child;
						const available_for_count = props.occupancy[time_slot.starts_at].limit - props.occupancy[time_slot.starts_at].count - count_cart;
						// only take selected count into account for groups
						const count_for_range     = props.price.group > 0 ? count_selected : (count_cart + count_selected);

						const hour_limit_for_reservation = props.findHourLimit(
							props.item.hour_limit_for_reservation,
							props.date,
							time_slot.time_idx
						) ?? 0;

						const at_limit = available_for_count == 0;
						
						// conditions
						const condition_above_limit                    = (available_for_count - count_selected) >= 0;
						const condition_not_found_in_cart              = count_cart <= 0;
						const condition_count_above_min                = (count_for_range + count_cart + props.occupancy[time_slot.starts_at].count) >= props.item.min_person_count;
						const condition_valid_child_ages               = valid_child_ages;
						const condition_above_min_child_age            = above_min_child_age;
						const condition_available_for_reservation_past = props.availableForReservation(null, props.date, time_slot.time_idx, time_slot.starts_at);
						const condition_available_for_reservation      = props.availableForReservation(props.item.hour_limit_for_reservation, props.date, time_slot.time_idx, time_slot.starts_at);

						const condition_available =
							condition_above_limit &&
							condition_not_found_in_cart &&
							condition_count_above_min &&
							condition_valid_child_ages &&
							condition_above_min_child_age &&
							condition_available_for_reservation_past &&
							condition_available_for_reservation;
						
						if ((!condition_above_limit && !at_limit) || !condition_not_found_in_cart || !condition_count_above_min || !condition_available_for_reservation) {
							show_error_message = true;
						}

						console.log({ item: props.item });
						
						return <button
							style={{ marginLeft: 4, marginRight: 4 }}
							onClick={() => props.onItemSelect(
								time_slot,
								// if soft_max_person_count is defined, add multiple items to cart (if needed)
								props.price.group > 0 && props.item.soft_max_person_count !== null ? Math.ceil(count_selected / props.item.soft_max_person_count) : 1
							)}
							className='button primary-button'
							disabled={!condition_available}
							data-disabled-reason={[
								'condition_above_limit='                    + (condition_above_limit                    ? 'true' : 'false'),
								'condition_not_found_in_cart='              + (condition_not_found_in_cart              ? 'true' : 'false'),
								'condition_count_above_min='                + (condition_count_above_min                ? 'true' : 'false'),
								'condition_valid_child_ages='               + (condition_valid_child_ages               ? 'true' : 'false'),
								'condition_above_min_child_age='            + (condition_above_min_child_age            ? 'true' : 'false'),
								'condition_available_for_reservation_past=' + (condition_available_for_reservation_past ? 'true' : 'false'),
								'condition_available_for_reservation='      + (condition_available_for_reservation      ? 'true' : 'false'),
							].join('; ')}
							data-limit={props.occupancy[time_slot.starts_at].limit}
							data-count={props.occupancy[time_slot.starts_at].count}>
							<div>{ time_slot.starts_at.split(':').slice(0, 2).join(':') }</div>
							{condition_available ? null : (!condition_available_for_reservation_past || at_limit
								? <div className='occupied generic'>{ trans.fe__accommodation_item__occupied[props.lang] }</div>
								: (
									<>
										{!condition_available_for_reservation && <div className='occupied time-limit'>{
											trans.fe__accommodation_item__unavailable_time_limit[props.lang].replaceAll('{time_limit}', hour_limit_for_reservation)
										}</div>}
										{condition_available_for_reservation && !condition_count_above_min && <div className='occupied min-person'>{
											trans.fe__accommodation_item__count_not_in_range_min[props.lang].replaceAll('{min_person}', props.item.min_person_count)
										}</div>}
										{condition_available_for_reservation && !condition_above_limit && <div className='occupied max-person'>{
											trans.fe__accommodation_item__count_not_in_range_max[props.lang].replaceAll('{max_person}', available_for_count)
										}</div>}
									</>
								)
							)}
						</button>;
					})}
				</div>
			</div>}
			{props.item.limit_to_email_inquiry === false ? null : <div className='buttons'>
				<div dangerouslySetInnerHTML={{ __html: trans.fe__accommodation_details_dialog__email_inquiry__button_description[props.lang] }} />
				<div className='buttons-wrapper'>
					<a href={
						'mailto:info@soca-adventure.com?' +
						'subject=' + encodeURI(trans.fe__accommodation_details_dialog__email_inquiry__subject[props.lang]	) + '&' +
						'body=' + encodeURI(trans.fe__accommodation_details_dialog__email_inquiry__body[props.lang]
							.replaceAll('{date}',        dateToLocalDate(props.date))
							.replaceAll('{adult_count}', props.person_count.adult)
							.replaceAll('{child_count}', props.person_count.child == 0 ? 0 : (
								props.person_count.child + ' (' + props.child_ages.join(',') + ')'
							))
						)
					} className='button primary-button' style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
						<div>{ trans.fe__accommodation_details_dialog__email_inquiry__button_title[props.lang] }</div>
					</a>
				</div>
			</div>}
			<div className='error-text additional-error-text'>{
				<>
					{show_error_message || valid_child_ages ? null : <div className='error-text mt-1'>
						{ trans.fe__accommodation_item__invalid_children_ages[props.lang] }
					</div>}
					{show_error_message || !valid_child_ages || above_min_child_age ? null : <div className='error-text mt-1'>
						{ trans.fe__accommodation_item__min_child_age[props.lang].replace('{age}', props.item.min_age) }
					</div>}
					{show_error_message && <div className='error-text mt-1' dangerouslySetInnerHTML={{
						__html: trans.fe__accommodation_item__unavailable_extended[props.lang]
					}} />}
				</>
			}</div>
		</div>
	</div>;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
